import { render, staticRenderFns } from "./ProtocolCard.vue?vue&type=template&id=1190a18c&scoped=true"
import script from "./ProtocolCard.vue?vue&type=script&lang=js"
export * from "./ProtocolCard.vue?vue&type=script&lang=js"
import style0 from "./ProtocolCard.vue?vue&type=style&index=0&id=1190a18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1190a18c",
  null
  
)

export default component.exports